(function(global) {
	"use strict";
	
	if (!global.BS) {
		global.BS = {};
	}
	var BS = global.BS;

	BS.Env = {
		// Supports ECMAScript 6 (ES2015)
		ES6: (function() {
			try {
				Function("(...arg)=>1; let a={fn(){}}");
				return true;
			} catch (e) {
				return false;
			}
		})(),
		// iOS
		iOS: /\biOS\b/.test(navigator.userAgent),
		// IE <=8
		legacy8: typeof window.getSelection !== "function",
	};

	BS.Event = {
		Tap: BS.Env.iOS ? "tap" : "click"
	};
	
})(this);
